export default __webpack_public_path__ + "static/MalindaS-96ef7fcf2472064f388892dd95d7af76.jpg";